import { render, staticRenderFns } from "./myHandsel.vue?vue&type=template&id=57f01f71&scoped=true&"
import script from "./myHandsel.vue?vue&type=script&lang=js&"
export * from "./myHandsel.vue?vue&type=script&lang=js&"
import style0 from "./myHandsel.vue?vue&type=style&index=0&id=57f01f71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f01f71",
  null
  
)

export default component.exports